export default [
  {
    title: "Data Source",
    icon: "mdi-details",
    to: "/datasources/1660934",
  },
  {
    title: "Reports",
    icon: "mdi-file-document",
    to: "/reports",
  },
  {
    title: "Rentals",
    icon: "mdi-package",
    to: "/rentals",
  },
  {
    title: "Rentals V2",
    icon: "mdi-package-variant-closed",
    to: "/rentals-v2",
  },
  {
    title: "Tickets",
    icon: "mdi-ticket",
    to: "/tickets",
  },
  {
    title: "Documents",
    icon: "mdi-file-document",
    to: "/documents",
  },
  {
    title: "Hardware",
    icon: "mdi-wrench",
    to: "/hardware",
  },
  {
    title: "UNS",
    icon: "mdi-hexagon-multiple",
    to: "/uns",
  },
];
